
import { useContext, useState } from 'react';
import BranchComponent from './BranchComponent';
import './style/branches.css';
import { AppContext } from '../../../contextApi/ContextApi';
import NotFound404 from '../../NotFound404';
import SearchTermFilter from '../../SearchTermFilter';

export default function Branches({website}) {
  const {primary_color, accent_color, hasBranches} = useContext(AppContext);
  const [branches, setBranches] = useState(website?.settings?.branches || []);
  if(!hasBranches) return <NotFound404/>
  const deployBrances=()=>{
    if(branches?.length === 0){
      return <h3 style={{margin:"0 auto", textShadow:`2px 2px 4px ${primary_color}`}}>{"אין לנו סניפים כרגע, אולי בהמשך :)"}</h3>
    }
    return (<div id='deployedBranchesDiv'>
      {branches?.map((val, inx)=>{
        return <BranchComponent key={`branchComponent_${inx}`} item={val}/>
      })}
    </div>)
  }
  return (
    <div id='branchesMainContainer' dir='rtl'>
        <h1 style={{margin:"50px auto",color:accent_color, textShadow:`2px 2px 4px ${primary_color}`}}>הסניפים שלנו</h1>
        {/* add a dropdown filter for isOpen => true/false */}
        <SearchTermFilter list={website?.settings?.branches} setList={setBranches} filterBy={{city:true, address:true}} searchInputPlaceholder={"חפש סניף לפי עיר או כתובת.."}/>
        {deployBrances()}
    </div>
  )
}
